module.exports = __webpack_public_path__ + "register/img/background-3500px.bb649b91.jpg";